import { Translatable } from "@icc/shared/helpers";

export class RollerEndRail {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Kod do wydruków */
    printCode: string;
    @Translatable({ model: 'Profiles' })
    name: string;
    shutterTypes: number[];
    colorGroupSetId: number | null;
    /** Zdjęcie */
    img: string;
    /** Opis */
    description: string;
    /** Waga */
    weight?: number;
    /** Rzeczywista wysokość listwy [mm] */
    height?: number;
    /** Widoczna wysokość */
    visibleHeight?: number;
    /** Maksymalna szerokość */
    maxWidth?: number;
    /** Umożliwia montaż zamka baskwilowego */
    allowsEspagnoletteLock?: boolean;
    /** Pasujące pancerze */
    profilesIds?: number[];
    /** Czy domyślny */
    isDefault?: boolean;
}
